import React, { useMemo } from "react";
import { Modal, StyleSheet, View } from "react-native";
import Loading from "./Loading";
import { BodyMediumText } from "./FormattedText";
import { useTheme } from "../hooks/use-theme";

type LoadingModalProps = {
    visible: boolean;
    text?: string;
};

export const LoadingModalContent = ({ text }: { text?: string }) => {
    const styles = useStyles();
    return (
        <View style={styles.container}>
            <View style={{ flex: undefined }}>
                <Loading style={{ flex: undefined }} />
                {text && (
                    <BodyMediumText style={[styles.markdown, { textAlign: "center" }]}>
                        {text}
                    </BodyMediumText>
                )}
            </View>
        </View>
    );
};
const LoadingModal: React.FC<LoadingModalProps> = ({ visible, text }) => {
    return (
        <Modal statusBarTranslucent navigationBarTranslucent visible={visible} animationType="fade">
            <LoadingModalContent text={text} />
        </Modal>
    );
};

const useStyles = () => {
    const { marginSize } = useTheme();
    return useMemo(
        () =>
            StyleSheet.create({
                container: {
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    borderColor: "blue",
                    backgroundColor: "white",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    opacity: 0.9,
                },
                markdown: {
                    flex: undefined,
                    marginTop: marginSize,
                    marginHorizontal: marginSize,
                },
            }),
        [marginSize],
    );
};

export default LoadingModal;
